import type { CategoryFacet } from '~/contracts/SearchRepositoryContract'

/**
 * Composable function to set the max price range
 * Will call useAsyncData to fetch the highest price in a certain category.
 * Reruns the function when the category changes.
 * Populates the maxPriceRange in the filter store.
 */
export function useSetMaxPriceRange(category: Ref<CategoryFacet>, searchTerm: Ref<string> | Ref<undefined>) {
  const { $facets } = useNuxtApp()

  const filterStore = useFilterStore()
  const { data, error } = useAsyncData(async () => {
    const response = await $facets.fetchMaxPriceRange(category.value, searchTerm?.value)
    return response
  }, {
    watch: [category, searchTerm],
    lazy: true,
    deep: false,
  })

  watch(data, () => {
    if (data.value)
      filterStore.setMaxPriceRange(data.value)
  })

  return { data, error }
}
